import { jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { IconBase } from "src/components/ui/IconBase";
export default memo(forwardRef(function IconSvgSuccess({
  className,
  "data-test-id": dataTest = "IconSuccess",
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(IconBase, { ...props, "data-test-id": dataTest, className, innerRef: ref, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M12 20.894a8.894 8.894 0 1 1 0-17.788 8.894 8.894 0 0 1 0 17.788zM11 14l-2.5-2.5-1 1.075L11 16l6-6-1-1-5 5z" }) }) });
}));
